import React, { useEffect, useState } from "react";
import Helpers from "../../helpers/shared.helper";
import Storage from "../../services/storage.service";
import Payments from "../../services/payments.service";
import Numbers from "../../services/numbers.service";
import Message from "../../views/shared/message.component";
import PaymentSuccess from "./payment-success";
import PaymentFailure from "./payment-failure";
import GTMService from "../../services/gtm.service";
import SpinnerTimeLoader from "../shared/timeLoading";
import checkModule from "../shared/checkModule";
import CONSTANTS from "../../services/constants.service";

let subscriptions = [];
const Confirmation = (props) => {
	const [showError, setShowError] = useState(false);
	const [customErrorCode, setCustomErrorCode] = useState("");
	const [success, setSuccess] = useState(false);
	const [failed, setFailed] = useState(false);
	const [loader, setLoader] = useState(true);
	const { isPaymentKsa } = checkModule;

	let params = {};



	const checkPayment = () => {
		setLoader(true);
		Storage.clear("paymentErrorStatus");
		if (window) {
			Helpers.log(window.location);
		}
		if (localStorage.getItem("order_id") && localStorage.getItem("status")) {
			let data = null;
			let order_id = null;
			let status = null;

			let order_id_obj = JSON.parse(localStorage.getItem("order_id"));
			let status_obj = JSON.parse(localStorage.getItem("status"));

			order_id = order_id_obj[Storage.get("session")];
			status = status_obj[Storage.get("session")];
			Helpers.log("order_id = " + order_id);

			// Some issue with the Order ID & Order Status
			if (order_id && status) {
				// Number Registration API 
				Numbers.fetchNumber("1", "1")
					.then(res => {
						let number = res.data["numbers"][0];
						if (number && number["BookingCode"]) {
							let booking_code = number["BookingCode"];
							Helpers.log("booking_code = " + booking_code);
							data = {
								order_id: order_id,
								status: status,
								booking_code: booking_code
							};
							Storage.set("paymentErrorStatus", true, true);
							// Payment Confirmation API
							Storage.set("calledFeatureConfirmation", true, true)
							Payments.confirm3d(data)
								.then(res => {
									if (res.status === 201) {
										setLoader(false);
										Storage.set("paymentSuccess", true, true)
										Storage.set("confirmSuccess", true, true);
										localStorage.removeItem('order_id');
									} else {
										setLoader(false);
										Storage.set("confirmFailed", true, true);
									}
								})
								.catch(error => {
									setLoader(false);
									Storage.set("confirmFailed", true, true);
								});
						} else {
							setLoader(false);
							// Number & Number Booking Failed to Fetch
							setShowError(true);
							setCustomErrorCode(res.code ? res.code : "42022");
							GTMService.action_on_payment_failed();
							Payments.actionClearPaymentStorage();
						}
					})
					.catch(error => {
						// Fetch Number Failed
						setLoader(false);
						Storage.set("confirmFailed", true, true);

						setLoader(false);
						setShowError(true);
						GTMService.action_on_payment_failed();
						setCustomErrorCode("12022");
						Payments.actionClearPaymentStorage();
					});
			} else {
				setLoader(false);
				Storage.set("paymentErrorStatus", true, true);
				setShowError(true);
				GTMService.action_on_payment_failed();
				setCustomErrorCode("52022");
				Payments.actionClearPaymentStorage();
			}
		} else {
			setLoader(false);
			// Handle If Fail
			if (!Storage.get("storage_cleared")) {
				Storage.set("paymentErrorStatus", true, true);
				setShowError(true);
				GTMService.action_on_payment_failed();
				setCustomErrorCode("62022");
				Payments.actionClearPaymentStorage();
			}
			Storage.clear("storage_cleared");
		}
	}
	const checkPaymentKSA = () => {
		setLoader(true);
		Storage.clear("paymentErrorStatus");
		if (window) {
			Helpers.log(window.location);
			Storage.clear("paymentFailedError");
			if (window.location.href.indexOf("?") !== -1) {
				let search = window.location.href.substring(
					window.location.href.indexOf("?") + 1
				);
				search = search.split("&");

				for (let v = 0; v < search.length; v++) {
					let pair = search[v].split("=");
					params[pair[0]] = pair[1];
				}


				if (window.localStorage.getItem("order_id")) {
					let payment_method = window.localStorage.getItem("selected_payment_method");
					let status = null;
					if (payment_method === CONSTANTS.PAYMENT_METHOD_TAP) {
						if (localStorage.getItem("status")) {
							let status_obj = JSON.parse(localStorage.getItem("status"));
							status = status_obj[Storage.get("session")];
						}
					}
					let order_id_obj = JSON.parse(
						window.localStorage.getItem("order_id")
					);
					let save_card_obj = JSON.parse(
						window.localStorage.getItem("save_card")
					);

					let order_id = order_id_obj[Storage.get("session")];
					let save_card = save_card_obj[Storage.get("session")];

					let status_data = payment_method === CONSTANTS.PAYMENT_METHOD_TAP ?
						status : params["status"];
					let data = {
						order_id: order_id,
						status: status_data,
						save: save_card
					};


					Helpers.log("order_id = " + order_id);
					Storage.set("paymentErrorStatus", true, true);
					Storage.set("calledFeatureConfirmation", true, true)
					Payments.verifyPayfortResponse(data)
						.then(response => {

							if (response.status === 201) {
								Numbers.fetchNumber("1", "1")
									.then(res => {
										let number = res.data["numbers"][0];

										if (number && number["BookingCode"]) {
											let booking_code = number["BookingCode"];

											Helpers.log("booking_code = " + booking_code);

											let data = {
												"Session-Id": Storage.get("session"),
												order_id: order_id,
												status: status_data,
												booking_code: booking_code,
												save: save_card
											};
											Storage.set("paymentFailedError", true, true);
											Payments.confirm3d(data)
												.then(res => {
													Storage.clear("paymentErrorStatus");
													if (res.status === 201) {
														Storage.set("paymentSuccess", true, true);
														Storage.set("confirmSuccess", true, true);
														localStorage.removeItem('order_id');				
														setLoader(false);

													} else {
														setLoader(false);
														Storage.set("confirmFailed", true, true);
														Storage.set("paymentErrorStatus", true, true);
														// throw new Error("confirm3dError");

													}
												})
												.catch(error => {
													setLoader(false);
													Storage.set("confirmFailed", true, true);
													Storage.set("paymentErrorStatus", true, true);
												});
										} else {
											// no number
											setLoader(false);
											Storage.set("confirmFailed", true, true);
											Storage.set("paymentErrorStatus", true, true);
										}
									})
									.catch(error => {
										setLoader(false);
										Storage.set("confirmFailed", true, true);
										Storage.set("paymentErrorStatus", true, true);
									});
							} else {
								setLoader(false);
								Storage.set("confirmFailed", true, true);
								Storage.set("paymentErrorStatus", true, true);
							}
						})
						.catch(error => {
							setLoader(false);
							Storage.set("confirmFailed", true, true);
							Storage.set("paymentErrorStatus", true, true);
						});
				} else {
					// no order id found
					setLoader(false);
					Storage.set("confirmFailed", true, true);
					Storage.set("paymentErrorStatus", true, true);
				}
			}
		}
	}


	useEffect(() => {
		if (!Storage.get("calledFeatureConfirmation", true)) {
			if (!Storage.get("confirmSuccess", true)) {
				if (isPaymentKsa) {
					checkPaymentKSA()
				} else {
					checkPayment();
				}
			}
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
        subscriptions.push(
            Storage.get_obsrv("confirmSuccess").subscribe(() => {
                const flowType = Storage.get("confirmSuccess", true);
                if(JSON.parse(flowType)) {
                    setSuccess(true);
					setLoader(false);
                }
            })
        );

        subscriptions.push(
            Storage.get_obsrv("confirmFailed").subscribe(() => {
                const flowType = Storage.get("confirmFailed", true);
                if(JSON.parse(flowType)) {
                    setFailed(true);
					setLoader(false);      
                }
            })
        );

        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        };
    }, []);

	return (

		<div className="loading-overlay">
			<div className="relative">
				{loader ? <SpinnerTimeLoader />
					:
					<>
						{showError ? <Message error={customErrorCode} /> : null}
						{Storage.get("confirmSuccess", true) || success ? <PaymentSuccess /> : null}
						{Storage.get("confirmFailed", true) || failed ? <PaymentFailure /> : null}

					</>
				}
			</div>
		</div>
	)
}

export default Confirmation;